import { render, staticRenderFns } from "./ValuationsTable.vue?vue&type=template&id=7b853df2&scoped=true&"
import script from "./ValuationsTable.vue?vue&type=script&lang=ts&"
export * from "./ValuationsTable.vue?vue&type=script&lang=ts&"
import style0 from "./ValuationsTable.vue?vue&type=style&index=0&id=7b853df2&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b853df2",
  null
  
)

export default component.exports